import { SiteAndSurveyOutputViewModel } from "../ViewModels/SiteAndSurveyoutputViewModel";
import { TravlDataViewModel } from "../ViewModels/TravlDataViewModel";

export function mapTravlToSiteAndSurveyArray(input: TravlDataViewModel[]): SiteAndSurveyOutputViewModel[] {
    return input.map(x => ({
        SiteId: x.SiteId,
        SourceOfData: x.SourceOfData,
        Name: x.Name,
        Business: x.Business,
        Address: x.Address,
        District: x.District,
        BoroughId: x.BoroughId,
        BoroughName: x.BoroughName,
        Postcode: x.Postcode,
        LocationCode: x.LocationCode,
        LocationCodeShortDesc: x.LocationCodeShortDescription,
        Easting: x.Easting,
        Northing: x.Northing,
        SiteNotes: x.SiteNotes,
        SurveyCode: x.SurveyCode,
        LandUseCode: x.LandUseCode,
        LandUseClass: x.LandUseClass,
        LandUseDesc: x.LandUseDesc,
        SurveyDate: x.SurveyDate,
        SurveyHrs1: x.SurveyHrs1,
        SurveyHrs2: x.SurveyHrs2,
        PTA: x.PTA,
        PTAL: x.PTAL,
        TripRate: x.TripRate,
        Monday: x.Monday,
        Tuesday: x.Tuesday,
        Wednesday: x.Wednesday,
        Thursday: x.Thursday,
        Friday: x.Friday,
        Saturday: x.Saturday,
        Sunday: x.Sunday,
        Open2Publc: x.Open2Publc,
        BikePark: x.BikePark,
        WorkProg: x.WorkProg,
        DelivSupp: x.DelivSupp,
        CostCode: x.CostCode,
        CostCodeShortDesc: x.CostCodeShortDescription,
        DisabledFacilitiesCode: x.DisabledFacilitiesCode,
        LongDescription: x.LongDescription,
        ManagedParkingCode: x.ManagedParkingCode,
        ManagedParkingCodeShortDesc: x.ManagedParkingCodeShortDescription,
        OwnerCode: x.OwnerCode,
        WaitingRestrictionCode: x.WaitingRestrictionCode,
        OtherMode: x.OtherMode,
        SurveyNote: x.SurveyNote,
        Facilities: x.Facilities,
        ExceptionalCircumstances: x.ExceptionalCircumstances,
        GFA: x.GFA,
        RFA: x.RFA,
        ParkTotal: x.ParkTotal,
        ParkedAtStart: x.ParkedAtStart,
        HomeHome: x.HomeHome,
        HomeWork: x.HomeWork,
        HomeElse: x.HomeElse,
        WorkHome: x.WorkHome,
        WorkWork: x.WorkWork,
        WorkElse: x.WorkElse,
        ElseHome: x.ElseHome,
        ElseWork: x.ElseWork,
        ElseElse: x.ElseElse,
        HasTripRateData: x.HasTripRateData,
        HasTravelPlanData: x.HasTravelPlanData,
        HasDeliveryData: x.HasDeliveryData,
        HasFreightSurveyData: x.HasFreightSurveyData,
        LatestSurveyForSite: x.LatestSurveyForSite,
        CurrentPredictorValue: x.CurrentPredictorValue,
        CurrentPredictorMultiplier: x.CurrentPredictorMultiplier,
        ConstructionPhaseID: x.ConstructionPhaseID,
        Description: x.Description,
        CanBeIssuedWithPCN: x.CanBeIssuedWithPCN,
    }));
}
